import { FAIcon } from "./faIcon";
import { InternalNode, SortableTreeNodeCommands, SortableTreeNode } from "./sortableTree";
import { Helper } from "../util/helper";
import React from "react";
export class Slot extends React.Component<SlotProps, any> {
    //HTML elements
    private _ref: HTMLDivElement = null;
    private _contentWrapperRef: HTMLDivElement = null;
    private _contentRef: HTMLDivElement = null;
    private _toggleRef: HTMLDivElement = null;
    //dragged
    private _isSelected = false;
    private _forceUnselect = false;
    //hover
    private _position = {
        x: 0,
        y: 0,
        offsetX: 0,
        offsetY: 0,
        initialX: 0,
        initialY: 0
    };
    private _mouseCaptureInfo: MouseCaptureInfo = {
        hasMouse: null,
        upperHalf: null
    };
    //v2
    private _isMoving = false;
    private _threshold = 5;
    private _contentOffsetX = 0;
    //end v2

    constructor(props: SlotProps) {
        super(props)
        if (props.serviceCommandManager) {
            props.serviceCommandManager.register(SortableTreeSlotServiceCommandType.Select, this._onServiceCommandSelect);
        }
    }

    private _setRef = (r: HTMLDivElement) => {
        this._ref = r;
        //https://www.kirupa.com/html5/drag.htm
        if (this._ref) {
            if (!this.props.isPlaceholder) {
                this._ref.addEventListener("mousedown", this._onMouseDown);
                //this._ref.addEventListener("touchstart", this._onMouseDown);
            }
        }
    }

    private _setContentWrapperRef = (r: HTMLDivElement) => {
        this._contentWrapperRef = r;

        if (this._contentWrapperRef) {
            this._contentWrapperRef.addEventListener("mouseenter", this._onMouseEnter);
            this._contentWrapperRef.addEventListener("mouseleave", this._onMouseLeave);
            this._contentWrapperRef.addEventListener("mousemove", this._onMouseHover);
            //this._contentWrapperRef.addEventListener("touchmove", this._onMouseMove);
        }
    }

    private _setContentRef = (r: HTMLDivElement) => {
        this._contentRef = r;
    }

    private _setToggleRef = (r: HTMLDivElement) => {
        this._toggleRef = r;

        if (this._toggleRef) {
            this._toggleRef.addEventListener("mousedown", this._toggleColapsed)
        }
    }

    private _getBoudingRectInfo = (e): BoundingRectInfo => {
        //cache info, the event will not be available in the timeout callback
        const rect = e.currentTarget.getBoundingClientRect();
        const info: BoundingRectInfo = {
            rect: rect,
            //mouse X location
            x: e.clientX,
            //distance from mouse to the left side
            offsetX: e.clientX - rect.left,
            //mouse Y location
            y: e.clientY,
            //distance from mouse to the top side
            offsetY: e.clientY - rect.top,
            content: {
                paddingLeft: 0,
                marginLeft: 0,
                offsetX: 0,
                offsetY: 0
            }
        };
        const contentRect = this._contentRef.getBoundingClientRect();
        info.content.offsetX = e.clientX - contentRect.left;
        info.content.offsetY = e.clientY - contentRect.top;

        return info;
    }

    private _updateInitialValues = (info: BoundingRectInfo) => {
        //compute initial values
        this._position.x = info.x;
        this._position.offsetX = info.offsetX;
        this._position.y = info.y;
        this._position.offsetY = info.offsetY;

        const rootInfo = this.props.rootInfoProvider();
        const rootTopOffset = info.rect.top - rootInfo.mouse.distanceToTop;
        const rootLeftOffset = info.rect.left - rootInfo.mouse.distanceToLeft;

        this._position.initialX = this._position.x - this._position.offsetX - rootLeftOffset;
        this._position.initialY = this._position.y - this._position.offsetY - rootTopOffset;
    }

    private _toggleDocumentEvents = (on: boolean) => {
        const f = on ? document.body.addEventListener : document.body.removeEventListener;

        f("mousemove", this._onMouseDrag);
        f("mouseup", this._onMouseUp);
        f("keyup", this._onKeyUp);
    }

    private _onMouseDown = (e) => {
        if (e.button === 0) {
            e.stopPropagation();
      //      e.preventDefault();

            if (this.props.node.parent) {
                const info = this._getBoudingRectInfo(e);
                this._updateInitialValues(info);

                this._contentOffsetX = info.content.offsetX;
                this._isSelected = true;

                this._toggleDocumentEvents(true);
            }
        }
    }

    private _triggerNodeSelection = (after: Function) => {
        if (!this.props.canBeSelected) {
            this.props.onContentSelected(this.props.node);
            if (after) {
                after();
            }
        } else {
            this.props.canBeSelected(this.props.node)
                .then(canSelect => {
                    if (canSelect) {
                        this.props.onContentSelected(this.props.node);
                        if (after) {
                            after();
                        }
                    }
                });
        }
    }

    private _updateMouseLocation = (e) => {
        const rect = this._contentWrapperRef.getBoundingClientRect();
        const offsetY = e.clientY - rect.top;
        const upperHalf = offsetY <= (rect.height / 2);
        if (this._mouseCaptureInfo.upperHalf !== upperHalf) {
            this._mouseCaptureInfo.upperHalf = upperHalf;
            return true;
        }

        return false;
    }

    private _onMouseEnter = (e) => {
        if (!this._mouseCaptureInfo.hasMouse && !this._isSelected) {
            this._mouseCaptureInfo.hasMouse = true;
            if (this._updateMouseLocation(e)) {
                this.props.onMouseCapture(this.props.node, { hasMouse: this._mouseCaptureInfo.hasMouse, upperHalf: this._mouseCaptureInfo.upperHalf });
            }
        }
    }

    private _onMouseLeave = (e) => {
        if (this._mouseCaptureInfo.hasMouse && !this._isSelected) {
            this._mouseCaptureInfo.hasMouse = false;
            this._mouseCaptureInfo.upperHalf = null;

            this.props.onMouseCapture(this.props.node, { hasMouse: false, upperHalf: null });
        }
    }

    private _onMouseDrag = (e: MouseEvent) => {
        if (!this.props.canNotDrag && this._isSelected) {
            if (this._isMoving) {
                //update position
                this._position.x = e.clientX;
                this._position.y = e.clientY;
                this.setState({});
            } else {
                //get deltas
                const dx = Math.abs(this._position.x - e.clientX);
                const dy = Math.abs(this._position.y - e.clientY);
                //the user has moved the mouse more than it's "allowed"
                if (dx >= this._threshold || dy >= this._threshold) {
                    //"first move"
                    this._isMoving = true;
                    this.props.onDragStart(this.props.node, this._ref.clientHeight, { contentOffsetX: this._contentOffsetX });
                }
            }
        }
    }

    private _onMouseUp = (e: MouseEvent) => {
        this._isSelected = false;
        if (this._isMoving) {
            this._release(false, true);
        } else {
            //wird wom IE11 nicht unterstützt
            const closestContent = (e.target as HTMLElement).closest("." + SlotClasses.Content);
            if (closestContent) {
                this._triggerNodeSelection(() => {
                    this._release(false, false);
                });
            }
        }
    }

    private _onKeyUp = (e: KeyboardEvent) => {
        if (e.keyCode === 27) {
            this._release(true, true);
        }
    }

    private _onMouseHover = (e) => {
        if (this._isSelected) {

        } else {
            if (this._mouseCaptureInfo.hasMouse) {
                let newLevel: number = null;
                if (this.props.isPlaceholder) {
                    const rect = this._contentRef.getBoundingClientRect();
                    const diff = e.clientX - rect.left - this.props.selection.contentOffsetX;
                    const skip = Math.floor((Math.abs(diff) / this.props.levelPaddingPixels)) * (diff < 0 ? -1 : 1);
                    if (skip !== 0) {
                        const candidateLevel = this.props.level + skip;
                        const newIdx = this.props.placeholderData.levels.indexOf(candidateLevel);
                        if (newIdx !== -1) {
                            newLevel = candidateLevel;
                        } else {
                            if (candidateLevel < this.props.placeholderData.levels[0]) {
                                newLevel = this.props.placeholderData.levels[0];
                            } else if (candidateLevel > this.props.placeholderData.levels[this.props.placeholderData.levels.length - 1]) {
                                newLevel = this.props.placeholderData.levels[this.props.placeholderData.levels.length - 1];
                            } else {
                                for (let i = 0; i < this.props.placeholderData.levels.length - 1; i++) {
                                    if (candidateLevel > this.props.placeholderData.levels[i] && candidateLevel < this.props.placeholderData.levels[i + 1]) {
                                        const diff1 = candidateLevel - this.props.placeholderData.levels[i];
                                        const diff2 = this.props.placeholderData.levels[i + 1] - candidateLevel;

                                        if (diff1 < diff2) {
                                            newLevel = this.props.placeholderData.levels[i];
                                        } else {
                                            newLevel = this.props.placeholderData.levels[i + 1];
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                const changed = this._updateMouseLocation(e);

                if (changed || newLevel !== null) {
                    this.props.onMouseCapture(
                        this.props.node,
                        {
                            hasMouse: true,
                            upperHalf: this._mouseCaptureInfo.upperHalf,
                            level: newLevel
                        }
                    );
                }
            }
        }
    }

    private _release = (cancel: boolean, triggerDragEnd: boolean) => {
        this._toggleDocumentEvents(false);
        this._forceUnselect = true;
        this.setState({}, () => {
            this._forceUnselect = false;
            this._isSelected = false;
            this._isMoving = false;
            if (triggerDragEnd) {
                this.props.onDragEnd(this.props.node, cancel);
            }
        });
    }

    private _createPlaceholderNode = (index: number, level: number) => {
        return {
            children: null,
            id: index.toString(),
            index: index,
            level: level,
            node: { canHaveChildren: false },
            parentNode: this.props.node.parentNode,
            parent: this.props.node.parent,
            collapsed: false,
            canTakeChildren: false

        } as InternalNode;
    }

    private _getPlaceholderProps = (index: number, level: number) => {
        const style: React.CSSProperties = {
            height: this.props.placeholderData.dropHeight + "px",
            position: "relative"
        };

        return {
            index: index,
            isPlaceholder: true,
            level: level,
            node: this._createPlaceholderNode(index, level),
            contentRenderer: () => (
                <div className={SlotClasses.Placeholder} style={style}>
                    {this.props.placeholderData.levels.length > 1 ? <div style={{ position: "absolute", left: "-40px", color: "gray" }}><FAIcon name="exchange" sameWidth={true} attributes={["2x"]} /></div> : null}
                </div>
            ),
            selection: this.props.selection,
            onDragStart: this.props.onDragStart,
            onDragEnd: this.props.onDragEnd,
            placeholderData: this.props.placeholderData,
            onMouseCapture: this.props.onMouseCapture,
            onContentSelected: this.props.onContentSelected,
            onToggle: this.props.onToggle,
            onCommand: this.props.onCommand,
            commandData: this.props.commandData,
            levelPaddingPixels: this.props.levelPaddingPixels,
            commands: this.props.commands,
            canBeSelected: this.props.canBeSelected,
            rootInfoProvider: this.props.rootInfoProvider,
            rightContentRenderer: this.props.rightContentRenderer,
            serviceCommandManager: this.props.serviceCommandManager
        } as SlotProps;
    }

    private _renderPlaceholder = (above: boolean) => {
        if (!this.props.isPlaceholder && this.props.placeholderData.target === this.props.index && this.props.placeholderData.levels.length > 0) {
            //if (this.props.placeholderData.location === PlaceholderLocation.AboveTarget && above || this.props.placeholderData.location === PlaceholderLocation.BelowTarget && !above) {
            return <Slot key={-1} {...this._getPlaceholderProps(-1, this.props.placeholderData.currentLevel)} />
            //}
        }

        return null;
    }

    private _toggleColapsed = (e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.node.collapsed = !this.props.node.collapsed;
        this.props.node.node.collapsed = this.props.node.collapsed;
        this.props.onToggle(this.props.node, this.props.node.collapsed);
        this.setState({});
    }

    private _onCommand = (cmd: ToolBoxCommand) => {
        this.props.onCommand(this.props.node, cmd, null);
    }

    private _showCommandButton = (cmd: ToolBoxCommand): boolean => {
        if (this.props.commands && this.props.commands.canShow) {
            if (cmd === ToolBoxCommand.Copy || cmd === ToolBoxCommand.Cut) {
                return this.props.commands.canShow(ToolBoxCommand.Append, this.props.node.node) && this.props.commands.canShow(cmd, this.props.node.node);
            } else {
                return this.props.commands.canShow(cmd, this.props.node.node);
            }
        } else {
            return true;
        }
    }

    private _renderCommandButton = (cmd: ToolBoxCommand, iconName: string, hint: string) => {
        if (this._showCommandButton(cmd)) {
            return (
                <div className={SlotClasses.MenuButton} onClick={e => this._onCommand(cmd)} title={hint}>
                    <FAIcon name={iconName} />
                </div>
            );
        } else {
            return null;
        }
    }

    private _renderCustomCommand = (name: string, iconName: string, hint: string, onClick: (name: string, node: SortableTreeNode) => void) => {
        if (!this.props.commands.canShow || !this.props.commands.canShow(ToolBoxCommand.Custom, this.props.node.node, name)) {
            return null;
        } else {
            return (
                <div className={SlotClasses.MenuButton} onClick={e => onClick(name, this.props.node.node)} title={hint} key={name}>
                    <FAIcon name={iconName} />
                </div>
            );
        }
    }

    private _renderCustomCommands = () => {
        if (this.props.commands && Array.isArray(this.props.commands.custom)) {
            return this.props.commands.custom.map(c => this._renderCustomCommand(c.name, c.iconName, c.hint, c.onClick));
        }

        return null;
    }

    private _onServiceCommandSelect = (nodeId: string, data?: any) => {
        if (nodeId === this.props.node.guid) {
            this._triggerNodeSelection(null);
        }
    }

    componentWillUnmount() {
        if (this._ref) {
            if (!this.props.isPlaceholder) {
                this._ref.removeEventListener("mousedown", this._onMouseDown);
                //this._ref.removeEventListener("touchstart", this._onMouseDown);
            }
        }
        if (this._contentWrapperRef) {
            this._contentWrapperRef.removeEventListener("mousemove", this._onMouseHover);
            //this._contentWrapperRef.removeEventListener("touchmove", this._onMouseMove);
            this._contentWrapperRef.removeEventListener("mouseenter", this._onMouseEnter);
            this._contentWrapperRef.removeEventListener("mouseleave", this._onMouseLeave);
        }

        if (this._toggleRef) {
            this._toggleRef.removeEventListener("mousedown", this._toggleColapsed);
        }

        this._toggleDocumentEvents(false);
    }

    render() {
        const classes: Array<string> = [SlotClasses.Slot];
        let style: React.CSSProperties = {
            //top: null,
            //left: null,
            //transform: "none"
        };
        if (this._isSelected && !this._forceUnselect && this._isMoving) {
            classes.push(SlotClasses.SlotSelected);
            //style.top = (this._position.y - this._position.offsetY) + "px";
            //style.left = (this._position.x - this._position.offsetX) + "px";
            const x = this._position.x - this._position.offsetX - this._position.initialX;
            const y = this._position.y - this._position.offsetY - this._position.initialY;
            style.transform = "translate(" + x + "px, " + y + "px)";
        }
        if (this.props.placeholderData.dropCandidates.indexOf(this.props.index) !== -1) {
            classes.push(SlotClasses.SlotDropCandidate);
        }
        const contentClasses: Array<string> = [];
        if (!this.props.isPlaceholder) {
            contentClasses.push(SlotClasses.Content);
            if (this.props.node.contentSelected) {
                contentClasses.push(SlotClasses.ContentSelected);
            }
            if (this.props.commandData.copyTarget === this.props.index || this.props.commandData.cutTarget === this.props.index) {
                contentClasses.push(SlotClasses.CommandSource);
            }
        }
        const arrowClasses: Array<string> = [];
        if (Array.isArray(this.props.node.children) && this.props.node.children.length > 0) {
            arrowClasses.push(SlotClasses.Toggle);
            if (this.props.node.collapsed) {
                arrowClasses.push(SlotClasses.ToggleClosed);
            } else {
                arrowClasses.push(SlotClasses.ToggleOpen);
            }
        }
        const wrapperStyles: React.CSSProperties = {
            paddingLeft: (this.props.level * this.props.levelPaddingPixels) + "px"
        };
        if (!this.props.isPlaceholder) {
            wrapperStyles.position = "relative";
            wrapperStyles.display = "flex";
            wrapperStyles.justifyContent = "space-between";
        }


        return (
            <>
                <div className={classes.join(" ")} style={style} ref={this._setRef}>
                    <div className={SlotClasses.ContentWrapper} style={wrapperStyles} ref={this._setContentWrapperRef}>
                        <div>
                            <div className={contentClasses.join(" ")} ref={this._setContentRef}>
                                {this.props.contentRenderer(this.props.node)}
                                {
                                    arrowClasses.length > 0 ?
                                        <div className={arrowClasses.join(" ")} ref={this._setToggleRef}>
                                            <FAIcon name={this.props.node.collapsed ? "angle-right" : "angle-down"} />
                                        </div>
                                        : null
                                }
                            </div>

                            {
                                this.props.node.contentSelected ?
                                    <div className={SlotClasses.Menu}>
                                        {this._renderCommandButton(ToolBoxCommand.Up, "angle-double-up", "Move Up")}
                                        {this._renderCommandButton(ToolBoxCommand.Down, "angle-double-down", "Move Down")}
                                        {this._renderCommandButton(ToolBoxCommand.Copy, "copy", "Copy")}
                                        {this._renderCommandButton(ToolBoxCommand.Cut, "cut", "Cut")}
                                        {this._renderCommandButton(ToolBoxCommand.Append, "level-down", "Append")}
                                        {this._renderCommandButton(ToolBoxCommand.Delete, "trash", "Delete")}
                                        {this._renderCustomCommands()}
                                    </div>
                                    : null
                            }
                        </div>
                        {
                            !this.props.isPlaceholder && this.props.rightContentRenderer ?
                                <div className={SlotClasses.RightContentWrapper}>{this.props.rightContentRenderer(this.props.node.node)}</div>
                                : null
                        }
                    </div>
                    {
                        //classes.indexOf(SlotClasses.SlotDropCandidate) !== -1 ?
                        //    <div style={{ left: (this.props.level * this.props.levelPaddingPixels) + "px", zIndex: -1 }} className={SlotClasses.SlotDropCandidateMarker}></div>
                        //    : null
                    }
                    {this._renderPlaceholder(false)}
                    {
                        !this.props.isPlaceholder && !this.props.node.collapsed && Array.isArray(this.props.node.children) ?
                            this.props.node.children.map(n => {
                                return (
                                    <Slot
                                        key={n.id}
                                        index={n.index}
                                        level={n.level}
                                        isPlaceholder={false}
                                        node={n}
                                        selection={this.props.selection}
                                        onDragStart={this.props.onDragStart}
                                        onDragEnd={this.props.onDragEnd}
                                        contentRenderer={this.props.contentRenderer}
                                        placeholderData={this.props.placeholderData}
                                        onMouseCapture={this.props.onMouseCapture}
                                        onContentSelected={this.props.onContentSelected}
                                        onToggle={this.props.onToggle}
                                        onCommand={this.props.onCommand}
                                        commandData={this.props.commandData}
                                        levelPaddingPixels={this.props.levelPaddingPixels}
                                        commands={this.props.commands}
                                        canBeSelected={this.props.canBeSelected}
                                        rootInfoProvider={this.props.rootInfoProvider}
                                        rightContentRenderer={this.props.rightContentRenderer}
                                        serviceCommandManager={this.props.serviceCommandManager}
                                        canNotDrag={this.props.canNotDrag}
                                    />
                                );
                            })
                            : null
                    }
                </div>
            </>
        )
    }
}

export interface SlotProps {
    levelPaddingPixels: number;
    index: number;
    level: number;
    node: InternalNode;
    isPlaceholder: boolean;
    placeholderData: PlaceholderData;
    selection: {
        contentOffsetX: number;
    };
    commandData: {
        cutTarget: number;
        copyTarget: number;
    };
    contentRenderer: (node: InternalNode) => JSX.Element;
    onDragStart: (node: InternalNode, height: number, locationInfo: { contentOffsetX: number }) => void;
    onDragEnd: (node: InternalNode, canceled: boolean) => void;
    onContentSelected: (node: InternalNode) => void;
    onMouseCapture: (node: InternalNode, captureInfo: MouseCaptureInfo) => void;
    onToggle: (node: InternalNode, isCollapsed: boolean) => void;
    onCommand: (node: InternalNode, command: ToolBoxCommand, data: Object) => void;
    commands?: SortableTreeNodeCommands;
    canBeSelected?: (node: InternalNode) => Promise<boolean>;
    rootInfoProvider: () => {
        mouse: {
            distanceToTop: number;
            distanceToLeft: number;
        };
    };
    rightContentRenderer?: (node: SortableTreeNode) => JSX.Element;
    serviceCommandManager?: SortableTreeSlotServiceCommandManager;
    canNotDrag?: boolean;
}

export interface PlaceholderData {
    target: number;
    dropHeight: number;
    //location: PlaceholderLocation;
    levels: Array<number>;
    currentLevel: number;
    dropCandidates: Array<number>;
}

export interface PlaceholderDescription {
    level: number;
    isDropTarget: boolean;
}

export interface MouseCaptureInfo {
    hasMouse: boolean;
    upperHalf: boolean;
    level?: number;
}

export interface SortableTreeSlotServiceCommandManager {
    register: (type: SortableTreeSlotServiceCommandType, action: (nodeId: string, data?: any) => void) => void;
    deregister: (type: SortableTreeSlotServiceCommandType, action: (nodeId: string, data?: any) => void) => void;
}

export enum PlaceholderLocation {
    AboveTarget = 0, BelowTarget = 1
}

export enum ToolBoxCommand {
    Up, Down, Cut, Copy, Append, Delete, Custom
}

export enum SortableTreeSlotServiceCommandType {
    Select = 0
}

enum SlotClasses {
    Slot = "slot",
    SlotSelected = "slot--selected",
    SlotDropCandidate = "slot--drop-candidate",
    SlotDropCandidateMarker = "slot__drop-marker",
    ContentWrapper = "slot__content-wrapper",
    Content = "slot__content-wrapper__content",
    ContentSelected = "slot__content-wrapper__content--selected",
    RightContentWrapper = "slot__right-content-wrapper",
    Toggle = "slot__toggle",
    ToggleOpen = "slot__toggle--open",
    ToggleClosed = "slot__toggle--closed",
    Menu = "slot__menu",
    MenuButton = "slot__menu__button",
    CommandSource = "slot__content-wrapper__content--command-source",
    Placeholder = "slot--placeholder"
}

interface BoundingRectInfo {
    rect: ClientRect;
    x: number;
    y: number;
    offsetX: number;
    offsetY: number;
    content: {
        paddingLeft: number;
        marginLeft: number;
        offsetX: number;
        offsetY: number;
    }
}